import angular from 'angular';

import account from './account';
import application from './application';
import cdp from './cdp';
import marketplace from './application/marketplace';
import chat from './chat';
import apiReference from './apiReference';
import login from './login';
import businessLogin from './businessLogin';
import message from './message';
import navbar from './navbar';
import shared from './shared';
import statistics from './statistics';
import { cache } from './cache';
import { distributionList } from './distributionList';
import { translateModule } from 'modules/translate';
import { eventReceiver } from 'modules/eventReceiver';
import { authorizeModule } from './authorize';
import { errorModule } from './error';
import { checkModule } from './check';
import blipStore from './blipStore';
import blipInsights from './blipInsights';
import blipSupport from './blipSupport';
import blipPayments from './blipPayments';
import blipConversationsInsights from './blipConversationsInsights';
import initialSetup from './initialSetup';
import onboarding from './onboarding';

export default angular.module('app.components', [
    translateModule,
    account,
    cdp,
    blipStore,
    blipInsights,
    blipSupport,
    blipPayments,
    blipConversationsInsights,
    application,
    marketplace,
    chat,
    apiReference,
    login,
    businessLogin,
    message,
    navbar,
    shared,
    statistics,
    cache,
    distributionList,
    authorizeModule,
    errorModule,
    eventReceiver,
    checkModule,
    initialSetup,
    onboarding,
]).name;
